/**
 * Created by jonas on 2021-02-19.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";

export class DasUBootCoverView extends PIXI.Container implements StageLayer{
    private cover:PIXI.Sprite;

    constructor() {
        super();
        this.name = "GameCover";
        this.cover = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.addChild(this.cover);
        this.cover.visible = false;
        this.cover.alpha = 0;
        this.onResize();
    }

    onResize():void {
        this.cover.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
        this.cover.width = NolimitApplication.screenBounds.width;
        this.cover.height = NolimitApplication.screenBounds.height;
    }

    public animate(duration:number,tint:number,  toAlpha:number, fromAlpha?:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        fromAlpha = fromAlpha ? fromAlpha : this.cover.alpha;

        tl.add(gsap.set(this.cover, {tint:tint}));
        tl.add(gsap.set(this.cover, {visible:true}));
        tl.add(gsap.set(this.cover, {alpha:fromAlpha}));
        tl.add(gsap.to(this.cover, {duration:duration, alpha:toAlpha}));

        if (toAlpha == 0){
            tl.add(gsap.set(this.cover, {visible:false}));
        }


        return tl;
    }
}